<div *ngIf="(pageVm$ | async) as pageVm">

    <app-page-header [vm]="pageVm" title='Vendor Payout' [fullHeader]="true" [canAddNew]="pageVm.canAddNew">
    </app-page-header>

    <div *ngIf="pageVm.contentVm as vm">
        <!-- tabs -->
        <div class="mt-3" *ngIf="!vm.workingText && !vm.errorText">
            <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'"
                (getActiveTab)="onGetActiveTab(vm, $event)">
                <mdb-tab heading="Payout">
                    <mdb-card cascade="true" narrower="true" class="my-3">
                        <mdb-card-body>
                            <div class="row mt-n4 mb-n4"
                                *ngIf="vm.dataVm.payoutTabVm && vm.dataVm.payoutTabVm.filterVm">
                                <div class="col-md-4">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-select [vm]="vm.dataVm.payoutTabVm.filterVm.reportTypeVm"
                                                [optionValue]="vm.dataVm.payoutTabVm.filterVm.data.reportType"
                                                (selectChanged)="reportTypeChanged($event, vm.dataVm.payoutTabVm, vm)"></app-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div *ngIf="vm.dataVm.payoutTabVm.warningMessage" class="mx-2 my-3">
                                        <div class="col-md-12 text-danger">
                                            <mdb-icon fas icon="exclamation-triangle" aria-hidden="true"></mdb-icon>
                                            &nbsp;<strong>{{vm.dataVm.payoutTabVm.warningMessage}}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4 mb-n4"
                                *ngIf="vm.dataVm.payoutTabVm && vm.dataVm.payoutTabVm.filterVm && vm.dataVm.payoutTabVm.filterVm.showInputRow">
                                <div class="col-md-2">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="vm.dataVm.payoutTabVm.filterVm.fromDateInputVm"
                                                (textChanged)="requestInputValidate(vm.dataVm.payoutTabVm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="vm.dataVm.payoutTabVm.filterVm.toDateInputVm"
                                                (textChanged)="requestInputValidate(vm.dataVm.payoutTabVm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-select [vm]="vm.dataVm.payoutTabVm.filterVm.vendorTypeVm"
                                                [optionValue]="vm.dataVm.payoutTabVm.filterVm.data.vendorType"
                                                (selectChanged)="vendorTypeChanged($event, vm.dataVm.payoutTabVm)"></app-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-select [vm]="vm.dataVm.payoutTabVm.filterVm.billingCycleVm"
                                                [optionValue]="vm.dataVm.payoutTabVm.filterVm.data.billingCycle"
                                                (selectChanged)="billingCycleChanged($event, vm.dataVm.payoutTabVm)"></app-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" *ngIf="vm.dataVm.payoutTabVm.showPaymentMethodOption">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-select [vm]="vm.dataVm.payoutTabVm.filterVm.paymentTypeVm"
                                                [optionValue]="vm.dataVm.payoutTabVm.filterVm.data.paymentMethodCode"
                                                (selectChanged)="paymentMethodSelectChanged($event, vm.dataVm.payoutTabVm)"></app-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" *ngIf="!vm.dataVm.payoutTabVm.showPaymentMethodOption">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mx-2 py-1">
                                        <div class="md-form form-group form-sm">
                                            <button (click)="buttonClicked(vm.dataVm.payoutTabVm)" type="button"
                                                [disabled]="vm.workingText || !vm.dataVm.payoutTabVm.isValid || vm.dataVm.payoutTabVm.disableSubmitButton"
                                                [ngClass]="!vm.dataVm.payoutTabVm.isValid || vm.dataVm.payoutTabVm.disableSubmitButton ? 'btn btn-outline-warning btn-sm waves-effect btn-block' : 'btn btn-outline-primary btn-sm waves-effect btn-block'">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                    <mdb-card cascade="true" narrower="true" class="my-3" *ngIf="vm.dataVm.payoutTabVm.showResultForm">
                        <mdb-card-body>
                            <!-- error text-->
                            <div class="row" *ngIf="vm.dataVm.payoutTabVm.errorText">
                                <div class="col-md-12 text-center text-danger">
                                    {{vm.dataVm.payoutTabVm.errorText}}
                                </div>
                            </div>
                            <!-- working text-->
                            <div class="row" *ngIf="vm.dataVm.payoutTabVm.workingText">
                                <div class="col-md-12 text-center text-info">
                                    <div>{{vm.dataVm.payoutTabVm.workingText}}</div>
                                    <mdb-spinner *ngIf="vm.dataVm.payoutTabVm.showSpinner"
                                        spinnerColor="blue"></mdb-spinner>
                                </div>
                            </div>
                            <div class="row" *ngIf="vm.dataVm.payoutTabVm.showDataChangeMessage">
                                <div class="col-md-12 text-center text-danger">
                                    <p>Heads up! Data has been updated since your last request.</p>
                                    <p>We've just refreshed our data to ensure you're always working with the most up-to-date information. Please submit data to see the latest changes.</p>
                                    <p>We apologize for any inconvenience this may cause.</p>
                                </div>
                            </div>
                            <ng-container
                                *ngIf="vm.dataVm.payoutTabVm.payoutResultPreviewVm && vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm && !vm.dataVm.payoutTabVm.showPreviewDetailForm">
                                <app-data-table-card
                                    [vm]="vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm"
                                    [showHeader]="false" [keyColumn]="0"
                                    (rowActionClick)="rowPreviewActionInvoke($event, vm, pageVm)">
                                </app-data-table-card>
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <app-form-ok-cancel *ngIf="vm.dataVm.payoutTabVm.payoutResultPreviewVm.okCancelVm" [vm]="vm.dataVm.payoutTabVm.payoutResultPreviewVm.okCancelVm" 
                                            [isInvalid]="!vm.dataVm.payoutTabVm.isReadyForProcess || !vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutPreviewVm.rowsFiltered?.length" (cancelClicked)="payoutDetailLoadEnd(vm.dataVm.payoutTabVm)" 
                                            (okClicked)="processButtonClicked(vm.dataVm.payoutTabVm)">
                                        </app-form-ok-cancel>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="vm.dataVm.payoutTabVm.payoutResultPreviewVm && vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm && vm.dataVm.payoutTabVm.showPreviewDetailForm">
                                <app-data-table-card-simple
                                    [vm]="vm.dataVm.payoutTabVm.payoutResultPreviewVm.vendorPayoutDetailPreviewVm"
                                    [showHeader]="false" [keyColumn]="0" [includeAction]="false">
                                </app-data-table-card-simple>
                                <div class="row my-2">
                                    <div class="col-md-12 text-center">
                                        <div>
                                            <button mdbBtn type="button" [rounded]="true" [outline]="true" size="sm"
                                                [color]="'success'" (click)="closeButtonClicked(vm.dataVm.payoutTabVm)"
                                                mdbWavesEffect>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- laod state form -->
                            <div class="row" *ngIf="vm.dataVm.payoutTabVm.fileLoadFormVm as fvm">
                                <div class="col-md-12">
                                    <!-- file loader -->
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mdb-file-upload (fileRemoved)="fileRemove(fvm)"
                                                (fileAdded)="fileAdd(fvm, $event)">
                                            </mdb-file-upload>
                                        </div>
                                    </div>

                                    <!-- process text-->
                                    <div class="row" *ngIf="fvm.processText">
                                        <div class="col-md-12 text-center text-info">
                                            {{fvm.processText}}
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="fvm.errorText">
                                        <div class="col-md-12 text-center text-danger">
                                            {{fvm.errorText}}
                                        </div>
                                    </div>

                                    <app-form-ok-cancel [vm]="fvm.okCancelVm" [isInvalid]="fvm.isInvalid"
                                        (cancelClicked)="formFileLoadEnd(vm.dataVm.payoutTabVm)"
                                        (okClicked)="fileLoadComplete(vm.dataVm.payoutTabVm, fvm)">
                                    </app-form-ok-cancel>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-tab>
                <mdb-tab heading="Vendor Information">
                    <!-- forms -->
                    <div *ngIf="vm.formVm as fvm" class="mt-3">
                        <div class="col-md-12">
                            <mdb-card narrower="true" cascade="true">
                                <div class="row">
                                    <div class="col-md-6">
                                        <app-card-header [headingSize]="5" [title]="fvm.title">
                                        </app-card-header>
                                    </div>
                                </div>
                                <mdb-card-body cascade="true">
                                    <ng-container *ngIf="fvm.data.action === 'delete'">
                                        <div class="text-center text-info">
                                            <strong>{{fvm.message}}</strong>
                                        </div>
                                        <br />
                                    </ng-container>
                                    <ng-container *ngIf="fvm.data.action !== 'delete'">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <app-form-input [vm]="fvm.vendorNumberInputVm"></app-form-input>
                                            </div>
                                            <div class="col-md-6">
                                                <app-form-input [vm]="fvm.vendorCodeInputVm"
                                                    (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <app-form-select [vm]="fvm.paymentMethodCodeInputVm"
                                                    [optionValue]="fvm.data.paymentMethodCode"
                                                    (selectChanged)="paymentMethodChanged($event, vm, fvm)"></app-form-select>
                                            </div>
                                            <div class="col-md-6">
                                                <app-form-input [vm]="fvm.addressCodeInputVm"
                                                    (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <app-form-select [vm]="fvm.billingCycleInputVm"
                                                    [optionValue]="fvm.data.billingCycle"
                                                    (selectChanged)="billingCycleInputChanged($event, vm, fvm)"></app-form-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <app-form-input [vm]="fvm.commentsInputVm"
                                                    (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                            </div>
                                        </div>
                                    </ng-container>
                                </mdb-card-body>
                            </mdb-card>
                            <app-form-ok-cancel *ngIf="fvm.okCancelVm" [vm]="fvm.okCancelVm" [isInvalid]="!fvm.isValid"
                                (cancelClicked)="formEnd(pageVm)" (okClicked)="requestFormOk(pageVm, vm, fvm)">
                            </app-form-ok-cancel>
                        </div>
                    </div>
                    <!-- main content -->
                    <div *ngIf="!vm.formVm">
                        <div class="offset-md-1 col-md-10 mt-3">
                            <div class="row" *ngIf="vm.dataVm.vendorInfoTabVm.workingText">
                                <div class="col-md-12 text-center text-info">
                                    <div>{{vm.dataVm.vendorInfoTabVm.workingText}}</div>
                                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- left side -->
                                <div class="col-md-4 mb-0">
                                    <!-- Search form -->
                                    <div class="form-inline md-form form-sm my-0">
                                        <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                                        <input class="form-control form-control-sm ml-5 w-75" type="search"
                                            [ngModel]="searchData" (ngModelChange)="doDataSearch(vm, $event)"
                                            placeholder="Search text">
                                    </div>
                                </div>
                                <!-- right side -->
                                <div class="col-md-2 mt-n4">
                                    <div class="md-form form-group form-sm">
                                        <mdb-checkbox [(ngModel)]="nonActiveRecords"
                                            (change)="nonActiveRecordsChanged(vm, $event)">Non Active Only
                                        </mdb-checkbox>
                                    </div>
                                </div>
                                <div class="col-md-2 mt-n4">
                                    <div class="md-form form-group form-sm">
                                        <mdb-checkbox [(ngModel)]="invalidRecords"
                                            (change)="invalidRecordsChanged(vm, $event)">Invalid Records
                                        </mdb-checkbox>
                                    </div>
                                </div>
                                <div class="col-md-4 mt-n4">
                                    <div class="md-form form-group form-sm">
                                        <app-form-select [vm]="vm.dataVm.vendorInfoTabVm.filterVm.vendorTypeVm"
                                            [optionValue]="vm.dataVm.vendorInfoTabVm.filterVm.data.vendorType"
                                            (selectChanged)="vendorInfoTypeChanged($event, vm)">
                                        </app-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3">
                                <app-data-table-card-simple [vm]="vm.dataVm.vendorInfoTabVm.vendorInfosVm"
                                    [showHeader]="false" [keyColumn]="0"
                                    (rowActionClick)="rowActionInvoke($event, vm, pageVm)">
                                </app-data-table-card-simple>
                            </div>
                        </div>
                    </div>
                </mdb-tab>
            </mdb-tabset>
        </div>
    </div>
</div>